import React, { Component, Fragment } from "react";
import Draggable from "react-draggable";
import { Document, Page, pdfjs } from "react-pdf";
import { connect } from "react-redux";
import moment from "moment";
import "./FilePreview.css";
import { getFileExtension } from "../../helper/util";
import ImageLoad from "../Common/ImageLoad2";
import MessageApi from "../../api/Message";
import { filter } from "lodash";
import { getFilesv3, setFiles } from "../../actions/ThreadAction";

const PDFThumbnail = require("../../assets/images/pdf.png");
const defualtPicture = require("../../assets/images/default.png");

export class index extends Component {
  constructor() {
    super();
    this.state = {
      defaultScale: 1,
      defaultDeg: 0,
      cantBeDrag: true,
      images: [],
      currentIndex: 0,
      openPopover: false,
      maxIndex: 0,
      page: 0,
      filterDate: {},
      lastMessageDate: {},
      firstMessageDate: {},
      hasMoreUp: true,
      hasMoreDown: true,
      test: null,
      isloading: true,
      fromThread: false,
      transformOrigin: "top left",
      transformRotate: "rotate(0deg)",
      transformScale: "scale(1)",
      threadId: null,
    };

    this.closeModal = this.closeModal.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.openPopover = this.openPopover.bind(this);
    this.closePopover = this.closePopover.bind(this);
  }

  // getSnapShotBeforeUpdate was used
  // so need to provide this thingy
  componentDidUpdate() {}

  componentDidMount() {
    if (this.props.isOpen) {
      this.refs.filePreview.style.display = "block";
    } else {
      this.refs.filePreview.style.display = "none";
    }

    const { images, currentIndex } = this.props;
    // const sliced = images.slice(0, currentIndex);
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    // Are we adding new items to the list?
    // Capture the scroll position so we can adjust scroll later.
    if (prevProps.isOpen != this.props.isOpen) {
      if (this.props.isOpen) {
        this.refs.filePreview.style.display = "block";

        if (this.props.threadId && this.state.threadId != this.props.threadId) {
          // new thread
          
          const uniqueArr = this.props.threads.files.filter(
            (item, index, self) =>
              index === self.findIndex(obj => obj.conversationId === item.conversationId)
          );
          const filterFiles = uniqueArr.map(item => ({
            ...item,
            isPDF: item.name.toLowerCase().includes('.pdf') || false
          }));
          const index = filterFiles.findIndex((msg) => msg.url === this.props.img);
          
          const length = this.props.threads.messages.length;
          const lastDate = 
            this.props.threads.messages[0].originalMessageDate
              ? this.props.threads.messages[0].originalMessageDate.iso
              : this.props.threads.messages[1].originalMessageDate.iso;
          const firstDate =
            this.props.threads.messages[length - 1].originalMessageDate
                ? this.props.threads.messages[length - 1].originalMessageDate.iso
                : this.props.threads.messages[length - 2].originalMessageDate.iso;

          this.setState({
            currentIndex: index > -1 ? index : 0,
            images: filterFiles,
            maxIndex: filterFiles.length,
            page: 0,
            isloading: false,
            threadId: this.props.threadId,
            lastMessageDate: lastDate,
            firstMessageDate: firstDate,
          });
          this.props.setFiles(filterFiles);

        } else if (this.props.threadId && this.state.threadId === this.props.threadId) {
          // same thread
          const uniqueArr = this.props.threads.files.filter(
            (item, index, self) =>
              index === self.findIndex(obj => obj.conversationId === item.conversationId)
          );
          const filterFiles = uniqueArr.map(item => ({
            ...item,
            isPDF: item.name.toLowerCase().includes('.pdf') || false
          }));
          const index = filterFiles.findIndex((msg) => msg.url === this.props.img);

          this.setState({
            images: filterFiles,
            currentIndex: index > -1 ? index : 0,
            isloading: false,
          });

        } else {
          // Document View page
          const filterFiles = this.props.threadFiles
            .filter(
              (img) =>
                img.fileType === "image/png" || 
                img.fileType === "application/pdf" || 
                img.fileType === "image/jpeg"
            )
            .map((img) => ({
              name: img.file.name,
              thumbUrl: img.thumbnail ? img.thumbnail.url : null,
              url: img.file.url,
              isPDF: img.fileType === "application/pdf" ? true : false,
            }));
          
          const length = this.props.threadFiles.length;
          const lastDate = this.props.threadFiles[length - 1].originalMessageDate.iso;
          const firstDate = this.props.threadFiles[0].originalMessageDate.iso;

          this.setState({
            images: filterFiles,
            maxIndex: filterFiles.length,
            page: 0,
            isloading: false,
            currentIndex: this.props.currentIndex - 1,
            hasMoreUp: true,
            lastMessageDate: lastDate,
            firstMessageDate: firstDate,
          });
        }

        
      } else {
        this.refs.filePreview.style.display = "none";
      }

      const { fromThread = false } = this.props;

      this.setState({
        fromThread: fromThread,
      });
    }
    return null;
  }

  getFilesv3(page, filterDate, queryUp = 0) {
    this.setState({ isloading: true });

    let newFilterDate = filterDate ? filterDate : new Date();

    if (page !== 0) {
      if (queryUp === 0) {
        newFilterDate = new Date(this.state.lastMessageDate);
      } else {
        newFilterDate = new Date(this.state.firstMessageDate);
      }
    }

    const threadId = window.location.pathname.slice(3);
    this.props
      .getFilesv3(threadId, {
        page: page,
        size: 5,
        filterDate: newFilterDate,
        queryUp: queryUp,
        oldFiles: this.state.images,
      })
      .then((res) => {

        if (page === 0) {
          const index = this.props.threadFiles.findIndex((msg) => msg.url === this.props.img);
          this.setState({
            currentIndex: index,
          });
        }

        const length = this.props.threadFiles.length;
        const lastDate =
          this.props.threadFiles[length - 1].originalMessageDate
              ? this.props.threadFiles[length - 1].originalMessageDate.iso
              : this.state.lastMessageDate;
        const firstDate =
          this.props.threadFiles[0].originalMessageDate
            ? this.props.threadFiles[0].originalMessageDate.iso
            : this.state.firstMessageDate;

        this.setState({
          images: this.props.threadFiles,
          maxIndex: this.props.threadFiles.length,
          page: page,
          isloading: false,
          lastMessageDate: lastDate,
          firstMessageDate: firstDate,
        });

        if (queryUp === 1) {
          const index = res.files.length + this.state.currentIndex;
          this.setState({
            currentIndex: index > 0 ? index : 0,
            hasMoreDown: res.hasMore,
          });
        } else {
          this.setState({
            hasMoreUp: res.hasMore,
          });
        }
      });
  }

  closeModal() {
    this.refs.filePreview.style.display = "none";
    this.props.modalClose();
  }

  zoomIn(e) {
    const { defaultScale } = this.state;

    if (defaultScale === 4) return;

    this.setState({
      defaultScale: defaultScale + 1,
      cantBeDrag: false,
      transformScale: `scale(${defaultScale + 1})`,
    });
  }

  zoomOut() {
    const { defaultScale } = this.state;

    if (defaultScale === 1) return;

    this.setState({
      defaultScale: defaultScale - 1,
      cantBeDrag: false,
      transformScale: `scale(${defaultScale - 1})`,
    });
  }

  next() {
    if (this.state.currentIndex + 1 >= this.state.maxIndex - 3) {
      if (this.state.hasMoreUp && this.state.fromThread) {
        this.getFilesv3(this.state.page + 1, "", 0);
      }
    }

    if (this.refs.imageContainer) {
      this.refs.imageContainer.style.transform = "translate(0px, 0px)";
    }
    if (this.refs.primaryImage) {
      this.refs.primaryImage.style.transform = "scale(1)";
    }

    this.setState({
      cantBeDrag: true,
      defaultScale: 1,
      defaultDeg: 360,
      currentIndex: this.state.currentIndex + 1,
    });
  }

  previous() {
    if (this.state.currentIndex - 1 <= 2) {
      if (this.state.hasMoreDown && this.state.fromThread) {
        this.getFilesv3(1, "", 1); // set page to 1 to update existing list
      }
    }

    if (this.refs.imageContainer) {
      this.refs.imageContainer.style.transform = "translate(0px, 0px)";
    }
    if (this.refs.primaryImage) {
      this.refs.primaryImage.style.transform = "scale(1)";
    }
    this.setState({
      currentIndex: this.state.currentIndex - 1,
      cantBeDrag: true,
      defaultScale: 1,
      defaultDeg: 360,
    });
  }

  thumbnailAction(data) {
    let index = this.state.images.indexOf(data);
    if (index < 0) return;
    if (this.refs.imageContainer) {
      this.refs.imageContainer.style.transform = "translate(0px, 0px)";
    }
    if (this.refs.primaryImage) {
      this.refs.primaryImage.style.transform = "scale(1)";
    }

    this.setState({
      currentIndex: index,
      cantBeDrag: true,
      defaultScale: 1,
      defaultDeg: 360,
    });
  }

  paginateThumbnail(items, index = 1) {
    let currentIndex = index + 1;
    if (items.length === 0) return [];
    let emptyIndex = 0,
      emptyLeftItems = [],
      emptyRightItems = [],
      leftItems = [],
      rightItems = [];
    // activeIndex is only 0, 1, 2 ,3

    if (currentIndex < 4) {
      emptyIndex = 4 - currentIndex;
      emptyLeftItems = [...Array(emptyIndex)].map(() => {
        return null;
      });
    }

    rightItems = items.slice(currentIndex - 1, currentIndex + 3);
    if (emptyIndex !== 0) {
      leftItems = items.slice(currentIndex - (4 - emptyIndex), currentIndex - 1);
    } else {
      leftItems = items.slice(currentIndex - 4, currentIndex - 1);
    }

    if (rightItems.length < 4) {
      let numberOfEmptyRight = 4 - rightItems.length;
      emptyRightItems = [...Array(numberOfEmptyRight)].map(() => {
        return null;
      });
    }

    // console.log(emptyLeftItems, leftItems, rightItems, emptyRightItems)

    let tempItems = [].concat.apply([], [emptyLeftItems, leftItems, rightItems, emptyRightItems]);
    // return object with all pager properties required by the view
    return tempItems;
  }

  downloadFile() {
    let url = this.state.images[this.state.currentIndex].url;
    if (!url) return;

    // Source: http://pixelscommander.com/en/javascript/javascript-file-download-ignore-content-type/

    //iOS devices do not support downloading. We have to inform user about this.
    if (/(iP)/g.test(navigator.userAgent)) {
      alert("Your device does not support files downloading. Please try again in desktop browser.");
      window.open(url, "_blank");
      return false;
    }

    //If in Chrome or Safari - download via virtual link click
    if (
      navigator.userAgent.toLowerCase().indexOf("chrome") > -1 ||
      navigator.userAgent.toLowerCase().indexOf("safari") > -1
    ) {
      //Creating new link node.
      var link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");

      if (link.download !== undefined) {
        //Set HTML5 download attribute. This will prevent file from opening if supported.
        var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
        link.download = fileName;
      }

      //Dispatching click event.
      if (document.createEvent) {
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        link.dispatchEvent(e);
        return true;
      }
    }

    // Force file download (whether supported by server).
    if (url.indexOf("?") === -1) {
      url += "?download";
    }

    window.open(url, "_blank");
    return true;
  }

  openPopover() {
    this.setState({
      openPopover: true,
    });
  }

  closePopover() {
    this.setState({
      openPopover: false,
    });
  }

  rotate(direction) {
    const { defaultDeg } = this.state;

    let newDeg;

    if (direction === "left") {
      newDeg = defaultDeg - 90;
    } else if (direction === "right") {
      newDeg = defaultDeg + 90;
    }

    this.setState({
      defaultDeg: newDeg,
      transformRotate: `rotate(${newDeg}deg)`,
      transformOrigin: this.getTransformOrigin(newDeg),
    });
  }

  getTransformOrigin(degrees) {
    // 360 degress is same as 0 degrees
    if (Math.abs(degrees) >= 360) degrees %= 360;

    // Pad negative degrees by 360
    if (degrees < 0) degrees += 360;

    const orientation = degrees / 90;

    switch (orientation) {
      case 0:
        return "top left";
      case 1:
        return "bottom left";
      case 2:
        return "bottom right";
      case 3:
        return "top right";
    }
  }

  handleSelect(link) {
    if (this.props.onSelect) {
      this.props.onSelect(link);
    }
  }

  render() {
    const { transformOrigin, transformScale, transformRotate } = this.state;

    let paginate = this.paginateThumbnail(this.state.images, this.state.currentIndex);
    let Thumbnail = paginate.map((data, i) => {
      if (data === null) {
        return <div key={i} className="thumbnal" style={{ cursor: "auto" }}></div>;
      }

      let url = data.url;
      if (data.isPDF) {
        url = PDFThumbnail;
      }
      let imageStyle = {
        backgroundImage: "url(" + url + ")",
      };
      if (i === 3) {
        return <div key={i} className="thumbnal" style={imageStyle}></div>;
      }
      return (
        <div onClick={this.thumbnailAction.bind(this, data)} key={i} className="thumbnal" style={imageStyle}>
          <div className="Image-Overlay"></div>
        </div>
      );
    });

    let mainImage;
    let isPDF = false;
    let isIMG = true;
    let isVideo = false;
    let isAudio = false;
    let file;
    let senderProfile = defualtPicture;
    let senderName = "";
    let uploaderProfile = defualtPicture;
    let uploaderName = "";
    let date = "";
    let originalDateSent = "";

    const { links = [], fromThread = false } = this.props;
    const listImages = this.state.images;

    // if (this.state.images.length !== 0) {
    if (this.state.images.length !== 0 && !this.state.isloading) {
      file = this.state.images[this.state.currentIndex];

      mainImage = file.url;
      let fileExt = getFileExtension(mainImage);

      isAudio = file.fileType === "audio";
      isVideo = file.fileType === "video";
      isPDF = fileExt === "pdf" || false;
      isIMG = !isPDF;
    }

    let disabledZoomIn = false;
    let disabledZoomOut = false;

    if (this.state.defaultScale === 1) {
      disabledZoomOut = true;
    }

    if (this.state.defaultScale === 4) {
      disabledZoomIn = true;
    }

    return (
      <div ref="filePreview" className="File-Preview-Modal">
        <div className="doc-action-container">
          <button className="File-Action-Button" onClick={this.downloadFile.bind(this)}>
            <img
              style={{ width: "22px", marginRight: "10px" }}
              src={require("../../assets/images/file-download.png")}
            />
            <span style={{ fontSize: "15px" }}>Download</span>
          </button>
          {isPDF && (
            <a href={mainImage} target="_blank" className="File-Action-Button">
              <img style={{ width: "22px", marginRight: "10px" }} src={require("../../assets/images/view.png")} />
              <span style={{ fontSize: "15px" }}>View PDF</span>
            </a>
          )}
          <button className="File-Action-Button" onClick={this.closeModal} style={{ width: "32px" }}>
            {/* <img style={{ width: "100%" }} src={require("../../assets/images/close_file_preview.png")} /> */}
            <i className="fal fa-times fa-lg" style={{ color: "#dcdcdc" }} />
          </button>
        </div>
        <div className="File-Preview-Modal-Content2">
          <div className="row mr-0 ml-0" style={{ height: "100%" }}>
            <div className="col-md-12 p-0">
              <div className="File-Preview-Overlay">
                {this.state.currentIndex !== 0 && !this.state.isloading && (
                  <button className="Previous-Button" onClick={this.previous}>
                    <img
                      style={{ width: "100%", verticalAlign: "unset" }}
                      src={require("../../assets/images/back.png")}
                    />
                  </button>
                )}
                {this.state.currentIndex !== listImages.length - 1 && !this.state.isloading && (
                  <button className="Next-Button" onClick={this.next}>
                    <img
                      style={{ width: "100%", verticalAlign: "unset" }}
                      src={require("../../assets/images/next.png")}
                    />
                  </button>
                )}
              </div>

              <div className="File-Preview-Container">
                {!isVideo && isIMG && (
                  <div className="doc-action-view">
                    <button className="File-Action-Button" onClick={this.zoomIn} disabled={disabledZoomIn}>
                      <img
                        style={{ width: "22px", marginRight: "5px" }}
                        src={require("../../assets/images/zoom-in.png")}
                      />
                      <span style={{ fontSize: "15px" }}>Zoom In</span>
                    </button>
                    <button className="File-Action-Button" onClick={this.zoomOut} disabled={disabledZoomOut}>
                      <img
                        style={{ width: "22px", marginRight: "5px" }}
                        src={require("../../assets/images/zoom-out.png")}
                      />
                      <span style={{ fontSize: "15px" }}>Zoom Out</span>
                    </button>
                    <button className="File-Action-Button" onClick={this.rotate.bind(this, "left")}>
                      <img style={{ width: "21px" }} src={require("../../assets/images/rotate-left.png")} />
                      <span style={{ fontSize: "15px" }}></span>
                    </button>
                    <button className="File-Action-Button" onClick={this.rotate.bind(this, "right")}>
                      <img style={{ width: "21px" }} src={require("../../assets/images/rotate-right.png")} />
                      <span style={{ fontSize: "15px" }}></span>
                    </button>
                  </div>
                )}
                {isAudio ? (
                  <div ref="imageContainer" className="Main-Video">
                    <audio
                      controls
                      style={{
                        display: "block",
                        marginBottom: "10px",
                        marginTop: "10px",
                      }}
                    >
                      <source src={file.url} />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                ) : isVideo ? (
                  <div ref="imageContainer" className="Main-Video">
                    <video
                      style={{
                        maxHeight: "calc(100vh - 150px)",
                        display: "block",
                        width: "100%",
                      }}
                      key={1}
                      controls
                    >
                      <source src={file.url} />
                      Your browser does not support HTML5 video.
                    </video>
                  </div>
                ) : (
                  <div ref="imageContainer" className="Main-Image" style={{ transform: transformRotate }}>
                    {isPDF ? (
                      <Document
                        className="PDF-Document"
                        file={mainImage}
                        loading={
                          <div>
                            <i className="fas fa-circle-notch fa-spin"></i> Loading PDF
                          </div>
                        }
                      >
                        <Page pageNumber={1} className="PDF-Page" />
                      </Document>
                    ) : isIMG ? (
                      // <img className="Primary-Image" ref="primaryImage" draggable="false" src={mainImage} style={{ height: '100%', maxWidth: "100%", maxHeight: "calc(100vh - 190px)", marginTop: "40px", transform: transformScale, transformOrigin }} /> : ''
                      <a onClick={(e) => window.open(mainImage, "_blank")}>
                        <ImageLoad
                          imageURL={mainImage}
                          imageStyles={{
                            height: "100%",
                            maxWidth: "100%",
                            maxHeight: "calc(100vh - 190px)",
                            marginTop: "40px",
                            transform: transformScale,
                            transformOrigin,
                          }}
                        />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="Thumbnail-Container">{Thumbnail}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  threadFiles: state.thread.threadFiles,
});

export default connect(mapStateToProps, {
  getFilesv3,
  setFiles,
})(index);
